var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('DeletePopover',{on:{"delete":function($event){return _vm.$emit('delete')}}},[_c('i',{staticClass:"el-icon-error icon-button delete-icon-button"})])}
var staticRenderFns = []

export { render, staticRenderFns }